import { createGlobalStyle, css } from 'styled-components';

export const DatePickerInputPopoverStyles = createGlobalStyle(
  ({ theme }) => css`
    .mantine-DatePickerInput {
      &-day[data-in-range] {
        background: ${theme.palette.primary.bg};
      }
      &-day[data-selected] {
        color: ${theme.palette.neutral['00']} !important;
        background: ${theme.palette.primary.main};
      }
      &-day[data-selected]:hover {
        background: ${theme.palette.primary.dark};
      }
      &-day[data-weekend] {
        color: ${theme.palette.neutral['100']};
      }
      &-input:focus {
        outline: 2px solid ${theme.palette.neutral['100']};
      }
    }
  `
);
